module.exports = __webpack_public_path__ + "static/img/list-dreamWispNasalMask.13fb02a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-dreamWispNasalMask.png
// module id = tW4/
// module chunks = 1